import React, { memo, useCallback, useRef, useState, useMemo, useEffect } from 'react';
import { Grid } from '@chakra-ui/react';
import { AutocompleteInput, TextInput, Unform, Icon } from 'components';
import { debounce } from 'utils/debounce';
import { FormHandles } from '@unform/core';
import { objToQuery, queryToObj } from 'utils/query';
import { routePaths } from 'constants/routes';
import { RouteComponentProps } from 'react-router';
import { DownloadBtn } from './sytles';
import { ReportsGenerationModal } from '../ReportsGenerationModal';
import { getLawyers, Lawyer } from 'services/lawyers';
interface IProps {
  history: RouteComponentProps['history'];
}
interface IFormData {
  filtro: string;
  status: string;
  lawyer: string;
}

export const ToolbarComponent: React.FC<IProps> = ({ history }) => {
  const formRef = useRef<FormHandles>(null);
  const [openReportsGen, setOpenReportsGen] = useState<boolean>(false);
  const [lawyerOptions, setLawyerOptions] = useState<Lawyer[]>([]);

  const { filtro, status, lawyer } = useMemo(() => {
    return queryToObj(history.location.search) as {
      filtro?: string;
      status?: string;
      lawyer?: string;
    };
  }, [history.location.search]);

  const handleSearch = useCallback(() => {
    const formData = formRef.current?.getData() as IFormData;

    const query = objToQuery({ ...formData, page: 0 });

    history.replace(`${routePaths.filedDemands}?${query}`);
  }, []);

  useEffect(() => {
    (async () => {
      const { data } = await getLawyers();
      setLawyerOptions(data);
    })();
  }, []);

  return (
    <Unform initialData={{ filtro, status, lawyer }} formRef={formRef}>
      <Grid mt="1rem" mb="1rem" maxH="40px" templateColumns="repeat(3, 1fr)" gap={4}>
        <TextInput
          name="filtro"
          notErrorMargin
          backgroundColor="#fff"
          leftIcon={{ name: 'search', color: 1100 }}
          placeholder="Pesquisar"
          onInput={debounce(handleSearch, 500)}
          onKeyPress={(ev: any) => {
            const keyCode = ev.keyCode ? ev.keyCode : ev.which ? ev.which : ev.charCode;
            if (keyCode === 13) {
              if (ev.stopPropagation) {
                ev.stopPropagation();
                ev.preventDefault();
              }
            }
          }}
        />

        <AutocompleteInput
          name="lawyer"
          placeholder="Advogado"
          onSelectOption={debounce(handleSearch, 200)}
          options={lawyerOptions}
          optionLabel="name"
          optionValue="id"
        />
        <DownloadBtn
          onClick={() => setOpenReportsGen(true)}
          type="button"
          variant="secondary"
          outline
        >
          <Icon name="download" size={1.3} />
        </DownloadBtn>

        <ReportsGenerationModal open={openReportsGen} onClose={() => setOpenReportsGen(false)} />
      </Grid>
    </Unform>
  );
};
export const Toolbar = memo(ToolbarComponent);
